import { render, staticRenderFns } from "./ReturnsDetails.vue?vue&type=template&id=52911e08&scoped=true&"
import script from "./ReturnsDetails.vue?vue&type=script&lang=js&"
export * from "./ReturnsDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReturnsDetails.vue?vue&type=style&index=0&id=52911e08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52911e08",
  null
  
)

export default component.exports